import { render } from "./rgbDiv.vue?vue&type=template&id=73acd2fc"
import script from "./rgbDiv.vue?vue&type=script&lang=js"
export * from "./rgbDiv.vue?vue&type=script&lang=js"

import "./rgbDiv.vue?vue&type=style&index=0&id=73acd2fc&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__